import { useCallback } from "react";
import { useForm as useFormHook } from "react-hook-form-legacy";
import useCMS from "./useCMS";

function useForm(mode = "onBlur") {
  const form = useFormHook({
    mode
  });
  const { translations } = useCMS();

  const handleError = useCallback(
    name => (form.errors[name] ? form.errors[name] : null),
    [form]
  );

  const validateUntil = useCallback(
    (fields, name) =>
      form.trigger(fields.slice(0, fields.indexOf(name))),
    [form]
  );

  const registerField = useCallback(
    (name, isDateTimeInput = false) => {
      const extraProps = isDateTimeInput
        ? {
          unregister: form.unregister,
          setValue: form.setValue,
          setError: form.setError
        }
        : {};

      return {
        ...extraProps,
        name,
        register: form.register,
        error: handleError(name)
      };
    },
    [form, handleError]
  );

  const fieldRequired = {
    value: true,
    message: translations.thefieldismandatory
  };

  return {
    ...form,
    handleError,
    validateUntil,
    registerField,
    fieldRequired
  };
}

export default useForm;
